import request from 'services/axios'

export const getCashBoxMessages = async () => {
    const { data } = await request.get(
        `/ment/cashbox/invited-and-request-list/`
    )
    return data
}

export const getRequestMessageInPage2 = async (date: string) => {
    const { data }: { data: IRequestMessage } = await request.get(
        `/peripheral/message/request-messages-in-page-v2/${date}/`
    )
    return data
}
